(() => {
  const carousels = document.querySelectorAll('[data-bud-reviews-carousel]');

  carousels.forEach((carousel) => {
    const viewport = carousel.querySelector('[data-bud-reviews-viewport]');
    const previous = carousel.querySelector('[data-bud-reviews-prev]');
    const next = carousel.querySelector('[data-bud-reviews-next]');

    if (!viewport || !previous || !next) return;

    const updateButtons = () => {
      const maxScroll = viewport.scrollWidth - viewport.clientWidth - 2;
      previous.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= maxScroll;
    };

    const scrollByCard = (direction) => {
      const firstCard = viewport.querySelector('.bud-review-card');
      const gap = 24;
      const distance = firstCard ? firstCard.getBoundingClientRect().width + gap : viewport.clientWidth * 0.8;
      viewport.scrollBy({ left: distance * direction, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => scrollByCard(-1));
    next.addEventListener('click', () => scrollByCard(1));
    viewport.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });
})();
